import React from "react";
import {
  AiOutlineCalendar,
  AiOutlineShoppingCart,
  AiOutlineAreaChart,
  AiOutlineBarChart,
  AiOutlineStock,
} from "react-icons/ai";
import {
  FiShoppingBag,
  FiEdit,
  FiPieChart,
  FiBarChart,
  FiCreditCard,
  FiStar,
  FiShoppingCart,
  FiDatabase,
} from "react-icons/fi";
import {
  BsKanban,
  BsBarChart,
  BsBoxSeam,
  BsCurrencyDollar,
  BsShield,
  BsChatLeft,
} from "react-icons/bs";
import { BiColorFill } from "react-icons/bi";
import { IoMdContacts } from "react-icons/io";
import { RiContactsLine, RiStockLine } from "react-icons/ri";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import { HiOutlineRefresh } from "react-icons/hi";
import { TiTick } from "react-icons/ti";
import { GiLouvrePyramid } from "react-icons/gi";
import { GrLocation } from "react-icons/gr";
import { GiOpenGate, GiPapers, GiMoneyStack } from "react-icons/gi";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import { TbCapture } from "react-icons/tb";
import { MdBiotech, MdReceiptLong, MdPrecisionManufacturing, MdStorage, MdSupervisorAccount, MdAccountBalance } from "react-icons/md";
import { BsActivity } from "react-icons/bs";

export const themeColors = [
  {
    name: "blue-theme",
    color: "#1A97F5",
  },
  {
    name: "green-theme",
    color: "#03C9D7",
  },
  {
    name: "purple-theme",
    color: "#7352FF",
  },
  {
    name: "red-theme",
    color: "#FF5C8E",
  },
  {
    name: "indigo-theme",
    color: "#1E4DB7",
  },
  {
    color: "#FB9678",
    name: "orange-theme",
  },
];

export const sidebarmenu = [
  {
    title: "Dashboard",
    links: [
      {
        name: "Overview",
        icon: <FiBarChart />,
        displayName: "Overview",
      },
      {
        name: "Portfolio",
        icon: <BsBoxSeam />,
        displayName: "Portfolio",
      },
    ],
  },
  {
    title: "Watchlist",
    links: [
      {
        name: "WatchList",
        icon: <FiStar />,
        displayName: "Watchlist",
      },
    ],
  },
  {
    title: "Manual Trading",
    links: [
      {
        name: "TradeSetup",
        icon: <AiOutlineStock />,
        displayName: "Trade Setup",
      },
      {
        name: "Orders",
        icon: <FiShoppingCart />,
        displayName: "Orders",
      },
    ],
  },
  {
    title: "Algo Trading",
    links: [
      {
        name: "AlgoDashboard",
        icon: <MdPrecisionManufacturing />,
        displayName: "Algo Dashboard",
      },
    ],
  },
  {
    title: "Strategy",
    links: [
      {
        name: "Strategies/Modern",
        icon: <MdBiotech />,
        displayName: "Strategies",
        end: true,
      },
      {
        name: "Strategies/Modern/Backtesting",
        icon: <MdBiotech />,
        displayName: "Backtesting",
      },
    ],
  },
  {
    title: "Broker Platforms",
    links: [
      {
        name: "TradeAccounts",
        icon: <GiOpenGate />,
        // "Broker Accounts" everywhere — the screen lists connected accounts, and
        // its sub-flow below already says "Add Account". The section keeps the
        // "Broker Platforms" title above.
        displayName: "Broker Accounts",
      },
      {
        name: "AddTradeAccount",
        icon: <FiEdit />,
        displayName: "Add Account",
      },

    ],
  },
  {
    title: "Admin",
    links: [
      {
        name: "Admin",
        icon: <BsActivity />,
        displayName: "Live Connections",
        end: true,
      },
      {
        name: "Admin/BatchJobs",
        icon: <AiOutlineCalendar />,
        displayName: "Batch Jobs",
      },
      {
        name: "Admin/Models",
        icon: <MdBiotech />,
        displayName: "Models",
        adminOnly: true,
      },
      {
        name: "Admin/TradeEconomics",
        icon: <MdReceiptLong />,
        displayName: "Trade Economics",
        adminOnly: true,
      },
      {
        name: "InstrumentMaster",
        icon: <MdStorage />,
        displayName: "Instrument Master",
      },
      {
        name: "BrokerManagement",
        icon: <MdAccountBalance />,
        displayName: "Broker Management",
      },
      {
        name: "user-management",
        icon: <MdSupervisorAccount />,
        displayName: "User Management",
      },
      {
        name: "MarketDataManagement",
        icon: <FiDatabase />,
        displayName: "Market Data",
      },
    ],
  },
];
